<template>
    <hts-drawer
        v-model="visible"
        :custom="['header', 'footer']"
        :title="$t('labels.addDocument')"
        :submit="handleSubmitFormAddDocument"
        :rules="rules"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="resetField()">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-select
                            v-model="dataFormAddDocument.type"
                            :label="$t('labels.documentType')"
                            required
                            :items="listTypeDocument"
                            key-id="key"
                            key-label="value"
                            :color="color"
                            name="documentType"
                            prop="documentType"
                            @change="(data: any) => handleChangeType(data)" />
                        <hts-form-input
                            v-model="dataFormAddDocument.fileName"
                            :label="$t('labels.documentFileName')"
                            :color="color"
                            name="documentFileName"
                            prop="documentFileName" />
                        <hts-form-file
                            ref="file"
                            v-model="fileDocument"
                            :required="true"
                            type="file"
                            :label="$t('labels.document')"
                            name="document"
                            prop="document" />

                        <hts-form-input
                            v-model="dataFormAddDocument.description"
                            :label="$t('labels.description')"
                            :color="color"
                            name="description"
                            prop="description" />
                    </div>
                </hts-card>
            </div>
        </div>
    </hts-drawer>
</template>

<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  type: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['refreshDataTables'])

const _initForm = {
  document: '',
  fileName: '',
  type: '',
  description: ''
}

const rules = {
  document: 'required|fileSize:10',
  documentType: 'required'
}

const dataFormAddDocument = ref({ ..._initForm })
const fileDocument = ref<File | string>('')

const visible = ref(false)
const orderId = ref('')

const openAddDocument = (id: any) => {
  if (!id) {
    return
  }

  orderId.value = id
  visible.value = true
}
defineExpose({
  openAddDocument
})

const resetField = () => {
  fileDocument.value = ''
  dataFormAddDocument.value = { ..._initForm }
}

const listTypeDocument = [
  {
    key: 'BOOKING',
    value: $t('labels.booking')
  },
  {
    key: 'OTHER',
    value: $t('labels.other')
  }
]

const handleChangeType = (data: any) => {
  if (data.length > 0) {
    dataFormAddDocument.value.type = data[0].key
  }
}
const handleSubmitFormAddDocument = async () => {
  const dataForm = new FormData()
  dataForm.append('document', fileDocument.value)
  dataForm.append('fileName', dataFormAddDocument.value.fileName || '')
  dataForm.append('type', dataFormAddDocument.value.type || '')
  dataForm.append('description', dataFormAddDocument.value.description || '')
  const api = {
    method: 'POST',
    url: '/order/ID/document'
  }

  const res: any = await $api(api, { uriParams: { ID: orderId.value }, body: dataForm })
  const resData: any = res?.data.value

  if (resData?.success) {
    process.client && $toast().success($t('notifications.addSuccessDocument'))
    visible.value = false
    resetField()
    emits('refreshDataTables')
  }
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-1'
})

const closeOverSide = () => {
  visible.value = false
  resetField()
}
</script>
